import type { StockBreakdown } from './types';

export default function StockBreakdownBadges({ breakdown }: { breakdown: StockBreakdown }) {
    if (breakdown.total === 0) {
        return <span className="text-xs text-gray-400 dark:text-zinc-500">—</span>;
    }

    return (
        <div className="inline-flex flex-nowrap items-center gap-1 whitespace-nowrap">
            {breakdown.disponivel > 0 && (
                <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300">
                    📦 {breakdown.disponivel}
                </span>
            )}
            {breakdown.a_importar > 0 && (
                <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700 dark:bg-blue-950/50 dark:text-blue-300">
                    🚢 {breakdown.a_importar}
                </span>
            )}
            <span className="text-xs text-gray-500 dark:text-zinc-400">/ {breakdown.total}</span>
        </div>
    );
}
